import { createSlice } from '@reduxjs/toolkit';
import { logoutAdmin } from '~/api';
import { signinAdmin } from '~/apiTs';
import { Administrator } from '~/common/types/api/admin';
import { GMOASK_STATUS } from '~/constants/api';

const initialState: Administrator = {
  id: 0,
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    initialize: () => initialState,

    // 401エラーが発生したら初期化
    unauthorizedErrorRaised: () => initialState,

    change: (state, action) => ({
      ...state,
      ...action.payload.admin,
    }),
  },
  // 非同期はextraReducersで行う
  extraReducers: (builder) => {
    builder
      .addCase(signinAdmin.fulfilled, (state, action) => {
        if (action.payload.status === GMOASK_STATUS.OK) {
          return {
            ...state,
            id: action.payload.result.id,
          };
        }
        return { ...state };
      })
      .addCase(logoutAdmin.fulfilled, () => initialState);
  },
});

export const { initialize, unauthorizedErrorRaised, change } = adminSlice.actions;

// reducerをexportする
export default adminSlice.reducer;
